import api from './config'

export default {
  checkPermission: async (data) => {
    try {
      let opt = typeof data == 'object' ? JSON.stringify(data) : data
      let res = await api.post('/checkPermissions', { options: opt })
      if (res.data.result == 'ok') return true
    } catch (error) {
      console.warn(error)
    }
    return false
  },
  getFairConfig: () => api.get('/getFairConfig'),
  getSideBarItems: () => api.get('/sidemenuitems'),
  getLogo: () => api.get('/logo'),
  getReportReasons: () => api.get('/repreason'),
  getAllOnline: () => api.get('/users'),
  getProfile: (id) => {
    let link = '/users/'
    link += id ? id : 0
    return api.get(link)
  },
  changePasword: (obj) => api.post('/users/changePassword', obj),
  uploadProfileImage: (fd) => api.post('/users/image', fd),
  getImage: (params) => api.get('/users/image', { params }),
  deleteImages: (id) => {
    let link = '/users/image'
    if (id) link += '/' + id
    return api.delete(link)
  },
  deleteUserData: (data) => {
    api.delete('/users', { data })
    console.log(data, '1234')
  },
  // Get clickable elements
  getIntroElements: () => api.get('/intro'),
  getInfoBoothElements: () => api.get('/infopult'),
  getFloorsElements: () => api.get('/floors'),
  getConferencesElements: () => api.get('/conferences'),

  getUserPermissions: () => api.get('/checkPermissions/user'),
  login: (params) => api.post('/login', params),
  register: (params) => api.post('/registration', params),
  sendSSOToken: (params) => api.post('/sso', params),
  getResetPasswordEmail: (params) => api.post('/resetpassword', params),
  checkResetPasswordLink: (params) => api.get('/resetpassword', { params }),
  resetPassword: (params) => api.post('/resetpassword/reset', params),
  validate: (params) => api.get('/validate', { params }),
  loginWithToken: (params) => api.post('/tokenlogin', params),
  getCountries: (params) => api.get('/countries', { params }),
  closedPoll: (data) => api.post('/polls/answered', data),
  getQuestions: (params) => api.get('/polls', { params }),
  getConditional: (params) => api.get('/polls/getconditional', { params }),
  getDefaultColors: () => {
    return {
      data: null,
    }
  },
  getDirectMessages: () => api.get('/messages'),
  getMessages: (params) => api.get('/messages/dm', { params }),
  sendMessage: (params) => api.post('/messages/dm', params),
  getBoothMessages: (params) => api.get('/messages/room', { params }),
  sendBoothMessage: (params) => api.post('/messages/room', params),
  reportMessage: (params) => api.post('/messages/report', params),
  reportUser: (params) => api.post('/users/report', params),
  reportError: (params) => api.post('/report', params),
  getSpecificDM: (id) => api.post('/messages/dm/new', { usr_id: id }),
  updateProfile: (data) => api.patch('/users', data),
  deleteProfile: (id) => {
    let link = '/users'
    if (id) link += '/' + id
    return api.delete(link)
  },
  getPublicMessages: (params) => api.get('/messages/public', { params }),
  sendPublicMessage: (params) => api.post('/messages/public', params),
  checkSession: (tab_name) =>
    api.get('/users/status', { params: { tab_name } }),
  changePassword: (password, id, token) =>
    api.post('/users/' + id + '/changePassword', { password, token }),
  addBio: (formData, id) =>
    api.post('/users/' + id + '/data', formData, {
      headers: { 'Content-Type': 'multipart/formdata' },
    }),

  //Admin Login
  adminLogin: (params) => api.post('/admin/login', params),

  //Admin Approval
  getUsersAwaitingValidation: (params) =>
    api.get('/admin/validate', { params }),
  getRejectedUsers: (params) => api.get('/admin/rejected', { params }),
  validateUser: (params) => api.post('/admin/validate', params),
  rejectUser: (params) => api.post('/admin/rejected', params),

  //Admin Video
  getInfo: () => api.get('/admin/multimedia'),
  uploadFile: (formData) => {
    return api.post('/admin/multimedia', formData)
  },

  //Admin ReportedUsers
  getReportedUsers: (params) => api.get('/admin/report', { params }),
  ignoreReportedUser: (params) => api.post('/admin/report/ignore', params),
  banUser: (data) => api.delete('/admin/user', { data }),

  //Admin ReportedMessages
  getReports: (params) => api.get('/admin/report', { params }),
  ignoreReportedMessage: (params) => api.post('/admin/report/ignore', params),
  deleteReportedMessage: (data) => api.delete('/admin/message', { data }),

  //Admin Links
  getLinks: () => api.get('/admin/streaming'),
  editLink: (params) => api.patch('/admin/streaming', params),
  addLink: (params) => api.post('/admin/streaming', params),
  deleteLink: (data) => api.delete('/admin/streaming', { data }),

  //Admin Add
  getUserRoles: () => api.get('userrole'),
  addNewUser: (params) => api.post('/admin/adduser', params),

  //Admin User Management
  getUsers: (params) => api.get('/admin/getusers', { params }),
  getUserCount: (params) => api.get('/admin/usernumber', { params }),
  changeUserPassword: (params) =>
    api.post('/admin/user/changepassword', params),
  editUser: (params) => api.patch('/admin/user/manage', params),
  deleteUser: (params) => api.delete('/admin/user/manage', { params }),

  //Admin Agenda
  getAllAgendas: (params) => api.get('/admin/agenda', { params }),
  getAgendas: () => api.get('/agenda'),
  getAgendaTypes: () => api.get('/agenda/types'),
  uploadImage: (data) => api.post('/admin/uploadImage', data),
  // getUsers: (params) => api.get('/users', {params}),
  // getCompanies: (params) => api.get('/companies', {params}),

  //Admin Company
  getCompanies: (params) => api.get('/companies', { params }),
  postCompany: (company) => api.post('/companies', company),
  deleteCompany: (cmp_id) => api.delete('/companies', { data: { cmp_id } }),

  //Frontend Agenda
  getFilteredAgendas: (params) =>
    api.get('/agenda?filter=' + JSON.stringify(params)),
  getBreakoutSessions: (params) => api.get('/agenda/breakout?agn_id=' + params),
  getMyAgenda: () => api.get('agenda/myagenda'),
  getMyAgendaFiltered: (params) =>
    api.get('agenda/myagenda?filter=' + JSON.stringify(params)),
  postMyAgenda: (params) => api.post('agenda/myagenda?agn_id=' + params),
  deleteMyAgenda: (params) => api.delete('agenda/myagenda?agn_id=' + params),
  getBooths: () => api.get('/booths'),
  getBoothsInfo: (params) => api.get('/agenda/boothdata', { params }),
  getAllBooths: () => api.get('/agenda/booth'),
  getAgendaLocations: () => api.get('/locations'),
  editAgenda: (params) => api.patch('/admin/agenda', params),
  deleteAgenda: (data) => api.delete('/admin/agenda', { data }),
  createAgenda: (params) => api.post('/admin/agenda', params),
  uploadPdf: (formData) => api.post('/admin/agenda/upload', formData),

  //Admin Templates
  getTemplates: () => api.get('/admin/templates'),
  editTemplate: (params) => api.patch('/admin/templates', params),
  addTemplate: (params) => api.post('/admin/templates', params),
  getTemplateImage: (params) => api.get('/admin/templates/image', { params }),
  deleteTemplate: (data) => api.delete('/admin/templates', { data }),
  addTemplateImage: (formData) => api.post('/admin/templates/image', formData),

  //Admin Fair Management
  getFloors: () => api.get('admin/floors'),
  setFloor: (params) => api.post('/admin/floors', params),
  deleteFloor: (data) => api.delete('/admin/floors', { data }),
  setConference: (params) => api.post('admin/conferences', params),
  deleteConference: (data) => api.delete('admin/conferences', { data }),
  getBoothsOnFloor: (params) => api.get('/admin/floors/booths', { params }),
  setBooth: (params) => api.post('/admin/floors/booths', params),
  deleteBooth: (data) => api.delete('/admin/floors/booths', { data }),
  getContent: (params) => api.get('/admin/content', { params }),
  getContentDoctypes: () => api.get('/contentdoctype'),
  getContentGroups: () => api.get('/contentgroups'),
  getContentTypes: () => api.get('/contenttype'),
  setContent: (params) => api.post('/admin/content', params),
  patchContent: (params) => api.patch('/admin/content', params),
  deleteContent: (data) => api.delete('/admin/content', { data }),

  //Admin Poll Management
  getAllPolls: (params) => api.get('/admin/polls', { params }),
  getSinglePoll: (params) => api.get('/admin/polls/data', { params }),
  addNewPoll: (pollData) => api.post('/admin/polls', pollData),
  deletePoll: (pls_id) => api.delete('/admin/polls', pls_id),
  editPoll: (params) => api.patch('/admin/polls', params),
  addTagToPoll: (data) => api.post('/admin/polls/tags', data),
  updatePollQuestions: (pollData, pls_id) =>
    api.post('/admin/polls/data', { poll: pollData, pls_id: pls_id }),

  //Admin CSV
  setCsv: (formData) => api.post('/csv', formData),

  //Super Admin
  getServers: () => api.get('/admin/meta/servers'),
  getSites: () => api.get('/admin/meta/sites'),
  getSiteProtoDate: (url) => api.get(url),
  setFair: (params) => api.post('/admin/meta/createFair', params),
  getDomainForSite: (params) => api.get('/admin/meta/domains', { params }),
  setDomain: (params) => api.post('/admin/meta/domains', params),
  deleteDomain: (data) => api.delete('/admin/meta/domains', { data }),
  setSSLforDomain: (params) => api.post('/admin/meta/domain-cert', params),
  deleteFair: (params) => api.post('/admin/meta/deleteFair', params),

  //Admin Fair Config
  saveConfig: (params) => api.post('/admin/fair_config', params),
  getCfgKeys: () => api.get('/hasClickableElements'),
  setLocationStatus: (params) => api.post('/hasClickableElements', params),
  setFairMedia: (formData) => api.post('/admin/change_image', formData),
  //Side Menu Items
  getMenuItems: () => api.get('/sidemenuitems'),
  getMenuIcon: (id) => api.get('/sidemenuitems/' + id),
  setMenuItem: (params) => api.post('/sidemenuitems', params),
  editMenuItem: (params) => api.patch('/sidemenuitems', params),
  deleteMenuItem: (data) => api.delete('/sidemenuitems', { data }),

  //Edit Permissions
  getPermissions: () => api.get('/admin/permissions'),
  getPublicPermissions: () => api.get('/publicPermissions'),
  getRoles: () => api.get('/admin/roles'),
  createRole: (d) => api.post('/admin/roles', d),
  deleteRole: (rol_id) => api.delete('/admin/roles', { data: { rol_id } }),
  createSubPermission: (d) => api.post('/admin/permissions', d),
  deletePermission: (per_id) =>
    api.delete('/admin/permissions', { data: { per_id } }),
  bindPermToRole: (d) => api.post('/admin/roles/permissions', d),
  bindPermToUser: (d) => api.post('/admin/permissions/users', d),
  bindRoleToUser: (d) => api.post('/admin/roles/users', d),

  //Admin badges
  getBadges: () => api.get('/badges'),
  postBadge: (formData) =>
    api.post('/badges', formData, {
      headers: { 'Content-Type': 'multipart/formdata' },
    }),
  editBadge: (formData) =>
    api.patch('/badges', formData, {
      headers: { 'Content-Type': 'multipart/formdata' },
    }),
  deleteBadge: (data) => api.delete('/badges', { data }),
  getAllQuestionAnswers: () => api.get('/polls/answers'),

  //List of Attendees
  getAttendees: (params) => api.get('/getusers', { params }),
  getAttendeeCount: (params) => api.get('/getusers/count', { params }),
  getFilters: (params) => api.get('/getusers/additional', { params }),

  getVideo: () => api.get('/multimedia', { params: { type: 'vid' } }),
  logout: () => api.get('/logout'),
  getStream: (loc_id) => {
    return api.get('/streaming', { params: { loc_id: loc_id } })
  },
  getEmbeds: (params) => api.get('/streaming/ondemand', { params }),
  mixpanel: (data) => api.post('/integrations/mixpanel', data),
  getSupport: () => api.get('/support'),
  getBoothInfo: (booth) => api.get('/booths/' + booth + '/content'),
  getContentHtml: (boothObj) =>
    api.get(`/booths/${boothObj.booth}/content/${boothObj.con_id}`),
  postAnswers: (answers, usr_id, token) =>
    api.post('/polls', { usr_id, token, answers }),
  search: (search) => api.get('/search', { params: { search } }),
  getStartDateAndFairName: () => api.get('/start'),
  getBoothHtml: (booth) => api.get(`/booths/${booth}/html/`),
  getFloorHtml: () => api.get('/floor/html'),
  getVotes: (name) => api.get(`/likes/${name}`),
  getRandomString: (params) => api.get('/randomString', { params }),
  getLinkedInAccess: (params) => api.post('/sso', params),
  destroyTab: (tab_name) => api.get('/destroy-tab', { params: { tab_name } }),
  //Accessibility
  getAccessibility: () => api.get('/accessibility'),
  postAccessibility: (data) => api.post('/accessibility', data),
  patchAccessibility: (data) => api.patch('/accessibility', data),
  deleteAccessibility: (data) => api.delete('/accessibility', { data }),
  // clickable BBB element
  getClickLink: (link) => api.get('/users/bbb', { params: { meeting: link } }),
  // used for info submission on booths via clickable element - contact
  sendContactInformation: (params) => api.post('/booths/contact', params),
  getEvents: () => api.get('/events'),
  postTracking: (params) => api.post('/tracking', params),
  getAllTracking: (params) => api.get('/tracking', { params: params }),
  getAllTrackingCount: (params) =>
    api.get('/tracking/count', { params: params }),
  downloadTracking: (params) =>
    api.get('/tracking/download', { params: params }),

  //profile-picture-frames
  getRolePictureFrame: (ust_id) =>
    api.get('/users/pictureframe', { params: { ust_id } }),
  postRolePictureFrame: (params) => api.post('/users/pictureframe', params),

  //tags
  getTags: (params) => api.get('/tags', { params: params }),
  postTag: (tag_name) => api.post('/tags', tag_name),
  deleteTag: (data) => api.delete('/tags', { data }),
  patchTag: (data) => api.patch('/tags', data),
  countTags: () => api.get('/tags/count'),
  // Message center
  sendEmail: (params) => api.post('/mail', params),

  getNotifications: () => api.get('/users/notifications'),
  checkPolls: () => api.get('/users/checkpolls'),

  // resend confirmation meial upon registration
  resendEmail: (params) => api.post('/registration/resend', params),

  getFooterConfig: () => api.get('/footer'),
  postFooterConfig: (params) => api.post('/footer', params),
  postFooterImage: (data) => api.post('/footer/image', data),
  getFooterImage: (id) => api.get(`/footer/image/`, { params: { fdt_id: id } }),
  getCss: () => api.get(`/css?ts=${ Date.now() }`),
  postCss: formData => api.post('/css', formData, {
    headers: { 'Content-Type': 'multipart/formdata' },
  }),
  
}
